import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable react/prop-types */
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import CheckboxRadioBase from '../CheckboxRadioBase';
import withThemeProps from '../withThemeProps';
/**
 * Checkbox input with custom rendering.
 */

export var Checkbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _ref$checkmarkIcon = _ref.checkmarkIcon,
      checkmarkIcon = _ref$checkmarkIcon === void 0 ? FaCheck : _ref$checkmarkIcon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'checkbox' : _ref$type,
      rest = _objectWithoutProperties(_ref, ["checkmarkIcon", "type"]);

  return /*#__PURE__*/React.createElement(CheckboxRadioBase, _extends({
    checkmarkIcon: checkmarkIcon,
    ref: ref,
    type: type
  }, rest));
});
Checkbox.displayName = 'Checkbox';
export default withThemeProps(Checkbox, {
  section: 'checkbox',
  defaultVariant: 'default'
});